import { createI18n } from 'vue-i18n';

// Import your locale messages
import en from './locales/en';
import fr from './locales/fr';

const i18n = createI18n({

  locale: navigator.language.split('-')[0],
  //locale: 'en',
  fallbackLocale: 'fr', 
  messages: {
    en,
    fr,
  },
});

export default i18n;
